import { z } from 'zod'

export enum FeedbackCategory {
  INCORRECT_FACTS = 'incorrect_facts',
  TONE_OF_VOICE = 'tone_of_voice',
  ROBOTIC = 'robotic',
  TOO_GENERIC = 'too_generic',
  TOO_WORDY = 'too_wordy',
  NOT_HELPFUL = 'not_helpful',
  INCOMPLETE = 'incomplete',
  UNSAFE = 'unsafe',
}

export const rateSchema = z.object({
  session_id: z.string(),
  is_positive: z.boolean(),
  category: z.enum(FeedbackCategory).nullable().optional(),
  comment: z.string().nullable().optional(),
})

export const AiConversationFeedbackSchemas = {
  save: {
    request: z.object({
      data: rateSchema,
    }),
    response: z.undefined(),
    query: z
      .object({
        client_id: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
  },
  retrieve: {
    request: z.object({
      session_ids: z.array(z.string()),
    }),
    response: z.object({
      data: z.record(z.string(), rateSchema).nullable(),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
}

export type AiConversationRate = z.infer<typeof rateSchema>
